import { connect } from "react-redux";
import * as redux from 'redux'
import { Store, facetsActions, asyncActions, inputActions, searchParameterActions } from "dw_azsearchstore";
import { FacetsAction } from "dw_azsearchstore/dist/actions/facetsActions";
import { InputAction } from "dw_azsearchstore/dist/actions/inputActions";
import FacetBox from "../components/facetbox/Facetbox";
import { SearchParametersAction } from "dw_azsearchstore/dist/actions/searchParametersActions";
import i18n from "../i18n";

interface FacetboxContainerProps {
    resetAll: Function;
}

function getReturnType<RT>(expression: (...params: any[]) => RT): RT {
    return {} as RT;
}  

function mapStateToProps(state: Store.SearchState) {
    return state;
}

const getLanguageFullName = () => {
    let lang: React.ReactText = "English";
    switch (i18n.language){
        case "es": lang = "Spanish"; break;
        case "fr": lang = "French"; break;
        case "de": lang = "German"; break;
        case "pt": lang = "Portuguese"; break;
        case "nl": lang = "Dutch"; break;
        case "pl": lang = "Polish"; break;
        case "it": lang = "Italian"; break;
        case "ja": lang = "Japanese"; break;
        case "sv": lang = "Swedish"; break;
    }
    return lang; 
}

declare type DispatchPropsType = FacetsAction | InputAction | SearchParametersAction

const mapDispatchToProps = (dispatch: redux.Dispatch<DispatchPropsType>, ownProps: FacetboxContainerProps) => {
    return {
        resetFilters: () => {
            ownProps.resetAll();
            dispatch(inputActions.setInput(""));
            dispatch(facetsActions.clearFacetsSelections());
            dispatch(facetsActions.toggleCheckboxFacetSelection("Language", getLanguageFullName()));
            dispatch(searchParameterActions.updateSearchParameters({skip: 0}));
            dispatch(asyncActions.fetchSearchResultsFromFacet);
            window.scrollTo({top: 0, behavior: "smooth"});
        },
        preselectLanguage: () => {
            dispatch(facetsActions.toggleCheckboxFacetSelection("Language", getLanguageFullName()));
            window.scrollTo({top: 0, behavior: "smooth"});
        }
    }
}

const stateProps = getReturnType(mapStateToProps);
const dispatchProps = getReturnType(mapDispatchToProps);

export type FacetboxProps = typeof stateProps & typeof dispatchProps;

const FacetboxContainer = connect(mapStateToProps, mapDispatchToProps)(FacetBox)

export { FacetboxContainer };